"use client";
import { u } from "./useId-CFOlRH4L.mjs";
function i(e) {
  return u(e, "base-ui");
}
export {
  i as u
};
